module.exports = __webpack_public_path__ + "img/green_084.1a47d7d9.png";